<template>
  <div class="sp-page">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/splan/header-img.png" />
      <div class="header-title">Strategy & Plan</div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">

      <el-tab-pane label="UNESCO operational strategy on youth" name="planYouth">
        <planYoung></planYoung>
      </el-tab-pane>
      <el-tab-pane
        label="Moving forward the 2030 Agenda"
        name="plan2030"
      >
        <plan2030></plan2030>
      </el-tab-pane>

      <el-tab-pane
        label="Medium-Term Strategy for 2022-2029"
        name="plan2229"
      >
        <plan2229></plan2229>
      </el-tab-pane>
      <el-tab-pane
        label="Youth roadmap"
        name="plan2231"
      >
        <plan2231></plan2231>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import planYoung from "./components/planYoung.vue";
import plan2030 from "./components/plan2030.vue";
import plan2229 from "./components/plan2229.vue";
import plan2231 from "./components/plan2231.vue";
export default {
  components: {
    planYoung,
    plan2030,
    plan2229,
    plan2231,
  },
  data() {
    return {
      activeName: "planYouth",
      constants: {},
    };
  },
  methods: {
    handleClick: () => {},
  },
};
</script>
<style>
.mobile {
  .sp-page {
    padding-top: 50px !important;
    .page-content {
      .text {
        margin-top: 20px !important;
      }
      .more-btn {
        width: 60% !important;
        font-size: 16px !important;
        line-height: 20px !important;
        margin: 20px auto !important;
      }
    }
  }
}
</style>
<style scoped lang="scss">
.mobile {
  .sp-page {
    padding-top: 50px !important;
    ::v-deep .el-tabs {
      .el-tabs__header{
        padding: 0  10px !important;
      }
      .el-tabs__content {
        padding: 0 !important;
      }
      .el-tabs__nav-scroll {
        padding: 10px 0 !important;
      }
      .el-tabs__nav-next,
      .el-tabs__nav-prev, {
        margin-top: 8px;
      }
    }
  }
}
.sp-page {
  width: 100%;
  .page-header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
    }
  }
  ::v-deep .el-tabs {
    width: 100%;
    .el-tabs__content {
      padding: fh(60vh, pc) fw(200vw, pc);
    }
    .el-tabs__header {
      width: 100%;
      left: 0;
      background: #ececec;
      padding: 0 fw(200vw, pc);
      margin-bottom: 0;
    }
    .el-tabs__nav-scroll {
      padding: fh(30vh, pc) 0 !important;
    }
    .el-tabs__item {
      font-size: fh(16vh, pc);
      color: #999999;
      &.is-active {
        color: #333333;
        font-size: fh(18vh, pc);
      }
    }
    .el-tabs__active-bar {
      bottom: fh(-30vh, pc);
      background: #0077d4;
    }
  }
}
</style>
